import { Component, OnInit, signal } from '@angular/core';
import { Router } from '@angular/router';
import { LoginHeaderService } from 'src/libs/state/login-header.service';

@Component({
  selector: 'fini-login-error',
  templateUrl: './login-error.component.html',
  styleUrls: ['./login-error.component.scss'],
  standalone: false,
})
export class LoginErrorComponent implements OnInit {
  constructor(
    private router: Router,
    private header: LoginHeaderService,
  ) {
    // Push header data up the tree
    this.header.set({
      title: 'Uh-oh!',
      subtitle: "Something doesn't look right",
    });
  }

  message = signal('');

  ngOnInit(): void {
    const state = this.router.lastSuccessfulNavigation?.extras.state;
    if (!state) {
      return;
    }
    this.message.set(state.errMessage);
  }
}
